module.exports = __webpack_public_path__ + "static/media/plus.cecec658.svg";